import { loader } from 'graphql.macro';
import { useMutation } from '@apollo/client';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useNotificationContext } from '../context/notification-context';

const USER_PASSWORD_RESET_BY_EMAIL_MUTATION = loader(
  '../graphql/userPasswordResetByEmail.graphql'
);

export interface UserPasswordResetByEmailProps {
  email: string;
}

interface Response {
  userPasswordResetByEmail: {
    emailSent: boolean;
  };
}

interface UserPasswordResetByEmailResponse {
  sendEmail: (values: UserPasswordResetByEmailProps) => void;
  loading?: boolean;
  error?: Error;
}

const useUserPasswordResetByEmailMutation = (
  redirect?: boolean
): UserPasswordResetByEmailResponse => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { showNotification } = useNotificationContext();

  const [mutation, { loading, error }] = useMutation(
    USER_PASSWORD_RESET_BY_EMAIL_MUTATION,
    {
      onCompleted: (data: Response): void => {
        const emailSent = get(data, 'userPasswordResetByEmail.emailSent');

        if (emailSent) {
          showNotification(t('An email was sent'), 'success');
        }

        if (redirect) {
          navigate('/login');
        }
      },
      onError: (e) => {
        showNotification(e.message, 'error');
      }
    }
  );

  return {
    sendEmail: (values: UserPasswordResetByEmailProps): void => {
      mutation({ variables: values });
    },
    error,
    loading
  };
};

export default useUserPasswordResetByEmailMutation;
